import { MeldingsStatus } from '../interfaces';

export const getMeldingstatusFromId = (meldingsstatuser: MeldingsStatus[], statusid: number): MeldingsStatus | void => {
  if (meldingsstatuser) {
    return meldingsstatuser.find((e: MeldingsStatus) => e.id === statusid);
  }
};
